import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
import { volumes } from '../data/volumes';
export function VolumesSection() {
  return <section className="py-24 px-4 bg-black" data-id="element-249" data-mp="coiskmopx5mr">
      <div className="max-w-6xl mx-auto" data-id="element-250" data-mp="cn7t2z2b2k1g">
        <div className="text-center mb-16" data-id="element-251" data-mp="cm4yoh5rxzgs">
          <h2 className="text-4xl md:text-5xl font-serif font-bold mb-4" data-id="element-252" data-mp="7qhe6f28luhm">
            📘 I 6 Volumi di Metodologia della Ricerca Pro
          </h2>
          <p className="text-xl text-gold-light" data-id="element-253" data-mp="3g2vbpfzrxcrz">
            Materiale completo per l’aula
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 items-stretch" data-id="element-254" data-mp="3purciyt8vgzw">
          {volumes.map((volume, index) => <motion.article key={volume.number} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.3,
          delay: index % 2 * 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className={`bg-dark-card rounded-2xl border ${volume.popular ? 'border-gold shadow-[0_0_30px_rgba(212,175,55,0.15)]' : 'border-dark-border'} p-8 relative overflow-hidden flex flex-col h-full`} data-id="element-255" data-mp="3l3svty4cggw4" data-mpi={index}>
              <div className="flex items-start gap-4 mb-6" data-id="element-256" data-mp="2o67qdxacfn9o">
                <span className="text-4xl leading-none" aria-hidden="true" data-id="element-257" data-mp="1qhxy4a0d0dvr">
                  {volume.icon}
                </span>
                <div data-id="element-258" data-mp="1vhtsrin62syn">
                  <p className="text-gold font-bold text-sm uppercase tracking-wider" data-id="element-259" data-mp="20eu0rz3ku5se">
                    {volume.number}
                  </p>
                  <h3 className="text-2xl font-serif font-bold leading-tight mt-1" data-id="element-260" data-mp="24h7127zk1bhs">
                    {volume.title}
                  </h3>
                </div>
              </div>

              <p className="text-white font-medium mb-6 italic border-l-2 border-gold/50 pl-4" data-id="element-261" data-mp="3fusz6ine6nfg">
                {volume.subtitle}
              </p>

              <div className="mb-6" data-id="element-262" data-mp="1gsx8nzl8w39r">
                <h4 className="text-sm font-bold text-gray-400 uppercase tracking-wider mb-2 font-sans" data-id="element-263" data-mp="1bs9bew6faq73">
                  Cosa risolve in aula?
                </h4>
                <p className="text-gray-300 text-sm leading-relaxed" data-id="element-264" data-mp="1pp4vrks4k42g">
                  {volume.problem}
                </p>
              </div>

              <ul className="space-y-3 mb-8 flex-grow" data-id="element-265" data-mp="x3va4ponn9sn">
                {volume.bullets.map(bullet => <li key={bullet} className="flex items-start gap-3" data-id="element-266" data-mp="t2jh0a6ko6fp">
                    <CheckCircle2Icon size={18} className="text-gold shrink-0 mt-0.5" aria-hidden="true" data-id="element-267" data-mp="16t6gi4k5q0cu" />
                    <span className="text-gray-200 text-sm" data-id="element-268" data-mp="ec2hwxhetslz">{bullet}</span>
                  </li>)}
              </ul>

              <div className="bg-gold/10 border border-gold/30 rounded-xl p-4 mt-auto" data-id="element-269" data-mp="9chgmgerp863">
                <span className="text-gold font-bold block mb-1" data-id="element-270" data-mp="2kzjlduahgx2c">
                  Risultato:
                </span>
                <p className="text-white text-sm" data-id="element-271" data-mp="2psvx53u2d9do">{volume.result}</p>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}